
/**
 * @export
 * @enum {string}
 */
export enum LimitType {
    SEARCH_AND_UPDATE = 'SEARCH_AND_UPDATE',
    SEARCH = 'SEARCH',
    UPDATE = 'UPDATE',
    PROFILES = 'PROFILES',
    CREDITS = 'CREDITS',
    OVERAGE = 'OVERAGE'
}